const calendarStrings = {
    lastDay: '[Yesterday at] LT',
    sameDay: '[Today at] LT',
    nextDay: '[Tomorrow at] LT',
    lastWeek: '[Last] ddd [at] LT',
    nextWeek: '[Next] ddd [at] LT',
    null: 'Not yet',
    '': 'Not yet',
    '1970-01-01': 'Not yet',
    '1969-12-31': 'Not yet',
    '01/01/1970': 'Not yet',
    '12/31/1969': 'Not yet',
    '1969-12-31 16:00:00': 'Not yet',
    '1970-01-01 00:00:00': 'Not yet',
    sameElse: 'L'
};

const CalendarStrings = (s) => {
    return calendarStrings;
};

export default CalendarStrings
